export const ID_OTHER_PLACE = '4';
